<fui-heading [text]="'Subscription Product Groups'" [level]="5"></fui-heading>
Placeholder for future subscription product groups management feature.
